// Generate a unique device ID based on browser fingerprinting
export function generateDeviceId(): string {
  // Try to get existing device ID from localStorage
  const existingId = localStorage.getItem('tahta_device_id');
  if (existingId) {
    return existingId;
  }

  // Generate new device ID based on browser characteristics
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  
  if (ctx) {
    ctx.textBaseline = 'top';
    ctx.font = '14px "Arial"';
    ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = '#f60';
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = '#069';
    ctx.fillText('Tahta Device ID', 2, 15);
    ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
    ctx.fillText('Tahta Device ID', 4, 17);
  }

  const canvasData = canvas.toDataURL();
  const fingerprint = [
    navigator.userAgent,
    navigator.language,
    screen.colorDepth,
    screen.width + 'x' + screen.height,
    new Date().getTimezoneOffset(),
    navigator.hardwareConcurrency || 'unknown',
    canvasData
  ].join('|');

  // Create hash from fingerprint
  let hash = 0;
  for (let i = 0; i < fingerprint.length; i++) {
    const char = fingerprint.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }

  const deviceId = `device_${Math.abs(hash)}_${Date.now()}`;
  localStorage.setItem('tahta_device_id', deviceId);
  
  return deviceId;
}

// Get current device information
export function getDeviceInfo() {
  const hasTouchSupport = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  // Detect primary input type
  let pointerType = 'mouse';
  if (hasTouchSupport && window.matchMedia('(pointer: coarse)').matches) {
    pointerType = 'touch';
  } else if (window.matchMedia('(pointer: fine) and (hover: none)').matches) {
    pointerType = 'pen';
  }

  return {
    userAgent: navigator.userAgent,
    platform: navigator.platform || 'unknown',
    vendor: navigator.vendor || 'unknown',
    screenWidth: screen.width,
    screenHeight: screen.height,
    pixelRatio: window.devicePixelRatio || 1,
    touchSupported: hasTouchSupport,
    pointerType
  };
}

// Check if device is mobile
export function isMobileDevice(): boolean {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

// Check if device is tablet
export function isTablet(): boolean {
  const userAgent = navigator.userAgent.toLowerCase();
  const isIPad = /ipad/.test(userAgent);
  const isAndroidTablet = /android/.test(userAgent) && !/mobile/.test(userAgent);
  const screenSize = Math.min(screen.width, screen.height) >= 768;
  
  return isIPad || (isAndroidTablet && screenSize);
}

// Get device type
export function getDeviceType(): 'mobile' | 'tablet' | 'desktop' {
  if (isMobileDevice()) {
    return isTablet() ? 'tablet' : 'mobile';
  }
  return 'desktop';
}